module.exports = __webpack_public_path__ + "static/media/ic_cotizacion_debito.1c65967a.svg";